/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/LocationChooser/Loading"
  
}) {
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={4}
 text="..."
/>
{children}
</React.Fragment>)
}